module.exports = __webpack_public_path__ + "entry-150bfe9b/migros-photo-db7d82d393cfa5e4d6d257714bc0612b.webp";